/**
 * Page Access Logger — fires a page-view log entry per route change.
 *
 * A lean counterpart to fs-assistant's PageAccessLogger service: this is a
 * low-traffic marketing site, so batching/localStorage-backed retry queues
 * aren't needed. Each call sends a single-entry batch and swallows failures
 * (logging must never break the page).
 */
import { sendLogBatch } from '../api/pageAccessLog';
import { getSessionId } from '../utils/sessionManager';
import { generateId } from '../utils/ids';
import { APPLICATION_NAME } from '../config/api';
import { getUserIP } from '../utils/ipAddress';

export async function logPageAccess(path) {
  // Get user IP address (cached after first fetch)
  const userIP = await getUserIP();

  const entry = {
    id: generateId(),
    timestamp: new Date().toISOString(),
    page_path: path,
    user_id: 'anonymous',
    session_id: getSessionId(),
    referrer: document.referrer || '',
    user_agent: navigator.userAgent,
    user_ip: userIP,
    environment: process.env.NODE_ENV || 'production',
    Application: APPLICATION_NAME,
    web_application_url: window.location.origin,
    additional_data: {
      screen_size: `${window.screen.width}x${window.screen.height}`,
      viewport_size: `${window.innerWidth}x${window.innerHeight}`,
    },
  };

  sendLogBatch([entry]).catch((error) => {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[pageAccessLogger] failed to log page access:', error.message);
    }
  });
}
